import { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { HeatReportReducer } from "../reducers/HeatReportReducer";

const HeatReportContext = createContext({
	state: HeatReportReducer.getInitialState(),
	actions: HeatReportReducer.actions,
});

export const useHeatReportContext = () => useContext(HeatReportContext);

export const HeatReportProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: HeatReportReducer.getInitialState(),
		reducers: HeatReportReducer.caseReducers,
	});

	return (
		<HeatReportContext.Provider value={{ state, actions }}>
			{children}
		</HeatReportContext.Provider>
	);
};
